<template>
  <svg
    width="24px"
    height="24px"
    viewBox="0 0 24 24"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
  >
    <title>icons / 24x24 / validate</title>
    <g
      id="icons-/-24x24-/-validate"
      stroke="none"
      stroke-width="1"
      fill="none"
      fill-rule="evenodd"
      stroke-linecap="round"
      stroke-linejoin="round"
    >
      <g
        id="search"
        transform="translate(3.000000, 3.000000)"
        stroke="#97ABBE"
        stroke-width="2"
      >
        <circle id="Oval" cx="8" cy="8" r="8"></circle>
        <polyline
          id="Path"
          points="11.4363636 6 6.87386364 10.5625 4.8 8.48863636"
        ></polyline>
        <line x1="18" y1="18" x2="13.65" y2="13.65" id="Path"></line>
      </g>
    </g>
  </svg>
</template>

<script>
export default {
  name: "icon"
};
</script>